import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './JoinForm.css';

const JoinForm = () => {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    fonction: '',
    adresse: '',
    gouvernorat: '',
    gsm: '',
    email: '',
    facebook: '',
    whatsapp: '',
    parraineePar: '',
    entreprise: '',
    secteurActivite: '',
    produitsServices: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Envoyer les données à l'adresse email spécifiée
    const email = 'mohamedrassem.hammami1@gmail.com';
    const subject = 'Nouvelle demande d\'adhésion au FTLM';
    const body = `
      Nouvelle demande d'adhésion au FTLM :

      Nom: ${formData.nom}
      Prénom: ${formData.prenom}
      Fonction: ${formData.fonction}
      Adresse: ${formData.adresse}
      Gouvernorat: ${formData.gouvernorat}
      GSM: ${formData.gsm}
      E-mail: ${formData.email}
      Facebook: ${formData.facebook}
      WhatsApp: ${formData.whatsapp}
      Parrainée par: ${formData.parraineePar}
      Nom de l'entreprise: ${formData.entreprise}
      Secteur(s) d'activité: ${formData.secteurActivite}
      Produits ou services fournis: ${formData.produitsServices}
      
      Conditions & Mode d'adhésion:
      - Remplir la fiche d'adhésion
      - Photo d'identité
      - Paiement cotisation annuelle
    `;

    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Afficher une notification
    toast.success('Votre demande d\'adhésion a été envoyée avec succès!', {
      position: 'top-right',
      autoClose: 5000, // Fermer automatiquement après 5 secondes
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <div className='join-form-container'>
      <ToastContainer />
      <div className='join-form'>
        <h2 className='form-title'>Fiche d’adhésion</h2>
        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label>Nom :</label>
            <input type="text" name="nom" value={formData.nom} onChange={handleChange} required />
          </div>
          <div className='form-group'>
            <label>Prénom :</label>
            <input type="text" name="prenom" value={formData.prenom} onChange={handleChange} required />
          </div>
          <div className='form-group'>
            <label>Fonction :</label>
            <input type="text" name="fonction" value={formData.fonction} onChange={handleChange} required />
          </div>
          <div className='form-group'>
            <label>Adresse :</label>
            <input type="text" name="adresse" value={formData.adresse} onChange={handleChange} required />
          </div>
          <div className='form-group'>
            <label>Gouvernorat :</label>
            <input type="text" name="gouvernorat" value={formData.gouvernorat} onChange={handleChange} required />
          </div>
          <div className='form-group'>
            <label>GSM :</label>
            <input type="text" name="gsm" value={formData.gsm} onChange={handleChange} required />
          </div>
          <div className='form-group'>
            <label>E-mail :</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div className='form-group'>
            <label>Facebook :</label>
            <input type="text" name="facebook" value={formData.facebook} onChange={handleChange} />
          </div>
          <div className='form-group'>
            <label>WhatsApp :</label>
            <input type="text" name="whatsapp" value={formData.whatsapp} onChange={handleChange} />
          </div>
          <div className='form-group'>
            <label>Parrainée par :</label>
            <input type="text" name="parraineePar" value={formData.parraineePar} onChange={handleChange} />
          </div>
          <div className='form-group'>
            <label>Nom de l'entreprise :</label>
            <input type="text" name="entreprise" value={formData.entreprise} onChange={handleChange} />
          </div>
          <div className='form-group'>
            <label>Secteur(s) d'activité :</label>
            <select name="secteurActivite" value={formData.secteurActivite} onChange={handleChange} required>
              <option value="">Sélectionnez le secteur d'activité</option>
              <option value="Commerce">Commerce</option>
              <option value="Industrie">Industrie</option>
              <option value="Service">Service</option>
              <option value="Artisanat">Artisanat</option>
            </select>
          </div>
          <div className='form-group'>
            <label>Produits ou services fournis :</label>
            <textarea name="produitsServices" value={formData.produitsServices} onChange={handleChange} required />
          </div>

          {/* Conditions & Mode d'adhésion */}
          <div className='conditions'>
            <p>Conditions & Mode d'adhésion :</p>
            <ul>
              <li>Remplir la fiche d’adhésion</li>
              <li>Paiement cotisation annuelle NB : Envoyer les documents demandés à : mohamedrassem.hammami1@gmail.com</li>
            </ul>
          </div>

          <button type="submit" className="submit-btn">Envoyer</button>
        </form>
      </div>
    </div>
  );
};

export default JoinForm;
